import { type MouseEvent, type ReactNode, useEffect, useState } from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaClipboard, FaClipboardCheck } from 'react-icons/fa6';

const COPY_TIMEOUT = 5000;

export function CopyValue({
  value,
  renderedValue,
}: {
  value: string;
  renderedValue?: ReactNode;
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return undefined;
    }

    const timeout = setTimeout(() => setCopied(false), COPY_TIMEOUT);
    return () => clearTimeout(timeout);
  }, [copied]);

  async function handleCopy(evt: MouseEvent<HTMLElement>) {
    evt.stopPropagation();
    await navigator.clipboard.writeText(value);
    setCopied(true);
  }

  return (
    <OverlayTrigger
      placement="auto"
      overlay={<Tooltip>{copied ? 'Copied' : 'Copy to clipboard'}</Tooltip>}
    >
      <Card
        className="p-2 ps-1"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          flexDirection: 'row',
          cursor: 'pointer',
        }}
        onClick={(e) => {
          void handleCopy(e);
        }}
      >
        {copied ? (
          <FaClipboardCheck className="ms-1 flex-shrink-0" size="1.5em" />
        ) : (
          <FaClipboard className="ms-1 flex-shrink-0" size="1.5em" />
        )}
        <span style={{ wordBreak: 'break-all' }}>{renderedValue ?? value}</span>
      </Card>
    </OverlayTrigger>
  );
}
